import TopicDistribution from './TopicDistribution.container';

export default TopicDistribution;
